"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  height: auto;\n  left: 0;\n  padding: 4px 8px 8px;\n  margin: 0;\n  margin-top: -3px;\n  margin-bottom: 0;\n  border-radius: 0 0 4px 4px;\n  overflow-y: auto;\n  max-height: 25vh;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-left: -8px;\n  margin-right: -8px;\n  min-width: 336px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var prosemirror_utils_1 = require("prosemirror-utils");

var outline_icons_1 = require("outline-icons");

var styled_components_1 = __importStar(require("styled-components"));

var isUrl_1 = __importDefault(require("../lib/isUrl"));

var Flex_1 = __importDefault(require("./Flex"));

var Input_1 = __importDefault(require("./Input"));

var ToolbarButton_1 = __importDefault(require("./ToolbarButton"));

var LinkSearchResult_1 = __importDefault(require("./LinkSearchResult"));

var LinkEditor = /*#__PURE__*/function (_React$Component) {
  _inherits(LinkEditor, _React$Component);

  var _super = _createSuper(LinkEditor);

  function LinkEditor() {
    var _this;

    _classCallCheck(this, LinkEditor);

    _this = _super.apply(this, arguments);
    _this.discardInputValue = false;
    _this.initialValue = _this.href;
    _this.initialSelectionLength = _this.props.to - _this.props.from;
    _this.state = {
      selectedIndex: -1,
      value: _this.href,
      previousValue: "",
      results: {}
    };

    _this.componentWillUnmount = function () {
      if (_this.discardInputValue) {
        return;
      }

      if (_this.state.value === _this.initialValue) {
        return;
      }

      var href = (_this.state.value || "").trim();

      if (!href) {
        return _this.handleRemoveLink();
      }

      _this.save(href, href);
    };

    _this.save = function (href, title) {
      href = href.trim();
      if (href.length === 0) return;
      _this.discardInputValue = true;
      var _this$props = _this.props,
          from = _this$props.from,
          to = _this$props.to;

      if (!isUrl_1.default(href) && !href.startsWith("/")) {
        href = "https://".concat(href);
      }

      _this.props.onSelectLink({
        href: href,
        title: title,
        from: from,
        to: to
      });
    };

    _this.handleKeyDown = function (event) {
      switch (event.key) {
        case "Enter":
          {
            event.preventDefault();
            var _this$state = _this.state,
                selectedIndex = _this$state.selectedIndex,
                value = _this$state.value;
            var results = _this.state.results[value] || [];
            var onCreateLink = _this.props.onCreateLink;

            if (selectedIndex >= 0) {
              var result = results[selectedIndex];

              if (result) {
                _this.save(result.url, result.title);
              } else if (onCreateLink && selectedIndex === results.length) {
                _this.handleCreateLink(_this.suggestedLinkTitle);
              }
            } else {
              _this.save(value, value);
            }

            if (_this.initialSelectionLength) {
              _this.moveSelectionToEnd();
            }

            return;
          }

        case "Escape":
          {
            event.preventDefault();

            if (_this.initialValue) {
              _this.setState({
                value: _this.initialValue
              }, _this.moveSelectionToEnd);
            } else {
              _this.handleRemoveLink();
            }

            return;
          }

        case "ArrowUp":
          {
            if (event.shiftKey) return;
            event.preventDefault();
            event.stopPropagation();
            var prevIndex = _this.state.selectedIndex - 1;

            _this.setState({
              selectedIndex: Math.max(-1, prevIndex)
            });

            return;
          }

        case "ArrowDown":
          if (event.shiftKey) return;

        case "Tab":
          {
            event.preventDefault();
            event.stopPropagation();
            var _this$state2 = _this.state,
                _selectedIndex = _this$state2.selectedIndex,
                _value = _this$state2.value;

            var _results = _this.state.results[_value] || [];

            var total = _results.length;
            var nextIndex = _selectedIndex + 1;

            _this.setState({
              selectedIndex: Math.min(nextIndex, total)
            });

            return;
          }
      }
    };

    _this.handleFocusLink = function (selectedIndex) {
      _this.setState({
        selectedIndex: selectedIndex
      });
    };

    _this.handleChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var value, trimmedValue, results;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = event.target.value;

                _this.setState({
                  value: value,
                  selectedIndex: -1
                });

                trimmedValue = value.trim();

                if (!(trimmedValue && _this.props.onSearchLink)) {
                  _context.next = 14;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return _this.props.onSearchLink(trimmedValue);

              case 7:
                results = _context.sent;

                _this.setState(function (state) {
                  return {
                    results: Object.assign(Object.assign({}, state.results), _defineProperty({}, trimmedValue, results)),
                    previousValue: trimmedValue
                  };
                });

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                console.error(_context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleOpenLink = function (event) {
      event.preventDefault();

      _this.props.onClickLink(_this.href, event);
    };

    _this.handleCreateLink = function (value) {
      _this.discardInputValue = true;
      var onCreateLink = _this.props.onCreateLink;
      value = value.trim();
      if (value.length === 0) return;
      if (onCreateLink) return onCreateLink(value);
    };

    _this.handleRemoveLink = function () {
      _this.discardInputValue = true;
      var _this$props2 = _this.props,
          from = _this$props2.from,
          to = _this$props2.to,
          mark = _this$props2.mark,
          view = _this$props2.view,
          onRemoveLink = _this$props2.onRemoveLink;
      var _this$props$view = _this.props.view,
          state = _this$props$view.state,
          dispatch = _this$props$view.dispatch;

      if (mark) {
        dispatch(state.tr.removeMark(from, to, mark));
      }

      if (onRemoveLink) {
        onRemoveLink();
      }

      view.focus();
    };

    _this.handleSelectLink = function (url, title) {
      return function (event) {
        event.preventDefault();

        _this.save(url, title);

        if (_this.initialSelectionLength) {
          _this.moveSelectionToEnd();
        }
      };
    };

    _this.moveSelectionToEnd = function () {
      var _this$props3 = _this.props,
          to = _this$props3.to,
          view = _this$props3.view;
      var state = view.state,
          dispatch = view.dispatch;
      dispatch(prosemirror_utils_1.setTextSelection(to)(state.tr));
      view.focus();
    };

    return _this;
  }

  _createClass(LinkEditor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          dictionary = _this$props4.dictionary,
          theme = _this$props4.theme;
      var _this$state3 = this.state,
          value = _this$state3.value,
          selectedIndex = _this$state3.selectedIndex;
      var results = this.state.results[value.trim()] || this.state.results[this.state.previousValue] || [];
      var Tooltip = this.props.tooltip;
      var looksLikeUrl = value.match(/^https?:\/\//i);
      var suggestedLinkTitle = this.suggestedLinkTitle;
      var showCreateLink = !!this.props.onCreateLink && !(suggestedLinkTitle === this.initialValue) && suggestedLinkTitle.length > 0 && !looksLikeUrl;
      var showResults = !!suggestedLinkTitle && (showCreateLink || results.length > 0);
      return React.createElement(Wrapper, null, React.createElement(Input_1.default, {
        value: value,
        placeholder: showCreateLink ? dictionary.findOrCreateDoc : dictionary.searchOrPasteLink,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        autoFocus: this.href === ""
      }), React.createElement(ToolbarButton_1.default, {
        onClick: this.handleOpenLink,
        disabled: !value
      }, React.createElement(Tooltip, {
        tooltip: dictionary.openLink,
        placement: "top"
      }, React.createElement(outline_icons_1.OpenIcon, {
        color: theme.toolbarItem
      }))), React.createElement(ToolbarButton_1.default, {
        onClick: this.handleRemoveLink
      }, React.createElement(Tooltip, {
        tooltip: dictionary.removeLink,
        placement: "top"
      }, this.initialValue ? React.createElement(outline_icons_1.TrashIcon, {
        color: theme.toolbarItem
      }) : React.createElement(outline_icons_1.CloseIcon, {
        color: theme.toolbarItem
      }))), showResults && React.createElement(SearchResults, {
        id: "link-search-results"
      }, results.map(function (result, index) {
        return React.createElement(LinkSearchResult_1.default, {
          key: result.url,
          title: result.title,
          subtitle: result.subtitle,
          icon: React.createElement(outline_icons_1.DocumentIcon, {
            color: theme.toolbarItem
          }),
          onMouseOver: function onMouseOver() {
            return _this2.handleFocusLink(index);
          },
          onClick: _this2.handleSelectLink(result.url, result.title),
          selected: index === selectedIndex
        });
      }), showCreateLink && React.createElement(LinkSearchResult_1.default, {
        key: "create",
        title: suggestedLinkTitle,
        subtitle: dictionary.createNewDoc,
        icon: React.createElement(outline_icons_1.PlusIcon, {
          color: theme.toolbarItem
        }),
        onMouseOver: function onMouseOver() {
          return _this2.handleFocusLink(results.length);
        },
        onClick: function onClick() {
          _this2.handleCreateLink(suggestedLinkTitle);

          if (_this2.initialSelectionLength) {
            _this2.moveSelectionToEnd();
          }
        },
        selected: results.length === selectedIndex
      })));
    }
  }, {
    key: "href",
    get: function get() {
      return this.props.mark ? this.props.mark.attrs.href : "";
    }
  }, {
    key: "suggestedLinkTitle",
    get: function get() {
      var state = this.props.view.state;
      var value = this.state.value;
      var selectionText = state.doc.cut(state.selection.from, state.selection.to).textContent;
      return value.trim() || selectionText.trim();
    }
  }]);

  return LinkEditor;
}(React.Component);

var Wrapper = styled_components_1.default(Flex_1.default)(_templateObject());
var SearchResults = styled_components_1.default.ol(_templateObject2(), function (props) {
  return props.theme.toolbarBackground;
});
exports.default = styled_components_1.withTheme(LinkEditor);